import { render, staticRenderFns } from "./BasicDataStep.vue?vue&type=template&id=9a8eb066&scoped=true&"
import script from "./BasicDataStep.vue?vue&type=script&lang=js&"
export * from "./BasicDataStep.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataStep.vue?vue&type=style&index=0&id=9a8eb066&scoped=true&lang=css&"
import style1 from "./BasicDataStep.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8eb066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8eb066')) {
      api.createRecord('9a8eb066', component.options)
    } else {
      api.reload('9a8eb066', component.options)
    }
    module.hot.accept("./BasicDataStep.vue?vue&type=template&id=9a8eb066&scoped=true&", function () {
      api.rerender('9a8eb066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/steps/BasicDataStep.vue"
export default component.exports